import { store } from "../store";
let isLoggedIn = store.getters["isLoggedIn"];

export const isAuthenticated = function (to, from, next) {
  if (!isLoggedIn) next({ path: "/login" });
  else next();
};
